import React from 'react';
import { HubModuleCTA } from '../../../../../types';
import { getCallToActionAttrs } from '../../helpers';
import {
  Button,
  ButtonProps,
  ButtonSize,
  ButtonType,
  ButtonVariant,
} from '../../Button';
import styles from './CallToAction.module.scss';
import gtmService from '../../../../../utils/gtm';
import { CTAClickType } from '../../../../../utils/gtm/types';

export enum CallToActionAlign {
  left = 'left',
  center = 'center',
  right = 'right',
}

export interface CallToActionProps
  extends Omit<ButtonProps, 'to' | 'pathPrefix' | 'openInNewTab' | 'query'> {
  align: keyof typeof CallToActionAlign;
  link: HubModuleCTA;
  ga4?: {
    [key: string]: string;
  };
}

export function CallToAction({ align, link, ...props }: CallToActionProps) {
  const { ga4, onClick, variant, color } = props;
  const { url, label, ...attrs } = getCallToActionAttrs(link);

  const clickHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (ga4) {
      gtmService.ga4CTAClick({
        cta_link: url,
        cta_title: label,
        cta_align: align,
        cta_text_color: color,
        cta_style_variant: variant,
        ...ga4,
      } as unknown as CTAClickType);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <div className={styles[align]}>
      <Button
        to={url}
        onClick={(event) => clickHandler(event)}
        {...props}
        {...attrs}
      >
        {label}
      </Button>
    </div>
  );
}

CallToAction.defaultProps = {
  type: ButtonType.button,
  variant: ButtonVariant.contained,
  size: ButtonSize.large,
  fullWidth: false,
  align: CallToActionAlign.left,
};
